import { Typography, useMediaQuery, useTheme } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import React, { useContext } from "react"
import DarkButton from "~/components/Common/DarkButton"
import AppContext from "~/contexts/App"
import ClientContext from "~/contexts/Client"

import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import Box from "../../Common/Box"
import AccessLink from "../AccessLink"
import useStyles from "./styles"

const AccessLinks = () => {
  const classes = useStyles()
  const theme = useTheme()
  const { openDialog } = useContext(AppContext)
  const { client } = useContext(ClientContext)
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  const openCreateAccessLink = () => {
    let data = { client: client, action: "create" }
    openDialog("createEditAccessLink", data)
  }
  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="10px"
      >
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          <Typography
            variant="h3"
            color="primary"
            style={{ fontWeight: "700", marginRight: "8px" }}
          >
            Access Links
          </Typography>
        </Box>
        <PermissionsWrapper permissionGroup="admin">
          <DarkButton
            onClick={openCreateAccessLink}
            startIcon={
              <AddCircle
                fontSize="small"
                classes={{ root: classes.addCircle }}
              />
            }
          >
            New Access Link
          </DarkButton>
        </PermissionsWrapper>
      </Box>
      <Box
        marginBottom="10px"
        maxHeight={smDown ? "100%" : "400px"}
        overflow="auto"
      >
        {client?.access_codes?.length > 0 &&
          client?.access_codes?.map((accessLink, i) => {
            return (
              <AccessLink accessLink={accessLink} client={client} key={i} />
            )
          })}
      </Box>
    </>
  )
}

AccessLinks.propTypes = {}
export default AccessLinks
